import { render, staticRenderFns } from "./mzj_Main.vue?vue&type=template&id=11464be4&scoped=true&"
import script from "./mzj_Main.vue?vue&type=script&lang=js&"
export * from "./mzj_Main.vue?vue&type=script&lang=js&"
import style0 from "./mzj_Main.vue?vue&type=style&index=0&id=11464be4&prod&lang=scss&scoped=true&"
import style1 from "./mzj_Main.vue?vue&type=style&index=1&id=11464be4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11464be4",
  null
  
)

export default component.exports